/**
 * Capture les métadonnées du navigateur pour signature électronique
 * Conforme eIDAS (Signature Électronique Avancée)
 */

export interface SignatureMetadata {
  userAgent: string;
  browserLanguage: string;
  screenResolution: string;
  timezone: string;
  metadata: {
    platform: string;
    vendor: string;
    cookiesEnabled: boolean;
    doNotTrack: string | null;
  };
}

/**
 * Capture automatiquement les métadonnées du navigateur
 * Aucune friction pour l'utilisateur (capture transparente)
 */
export function captureSignatureMetadata(): SignatureMetadata {
  return {
    userAgent: navigator.userAgent || "",
    browserLanguage: navigator.language || "",
    screenResolution: `${screen.width}x${screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    metadata: {
      platform: navigator.platform || "",
      vendor: navigator.vendor || "",
      cookiesEnabled: navigator.cookieEnabled,
      doNotTrack: navigator.doNotTrack ?? null,
    },
  };
}

/**
 * Texte de consentement RGPD (Proposition 1 - Légal complet)
 */
export const CONSENT_TEXT = `J'accepte que mes données personnelles (nom, téléphone, adresse IP, navigateur, localisation approximative) soient collectées et conservées pour preuve de signature électronique conforme au règlement eIDAS et au RGPD. Ces données sont conservées 10 ans à des fins légales.`;
